<template>
    <div class="row mt-1 mx-1">
        <div class="table-responsive mx-0 px-0">
            <table id="result-tbl"
                class="table align-middle table-sm table-bordered table-hover text-center">
                <thead>
                    <tr id="match-header">
                        <th scope="col" class="result-tbl-width" nowrap>種目<br>番号</th>
                        <th scope="col" class="result-tbl-width" nowrap>予定<br><span class="court">コート</span></th>
                        <th scope="col" colspan="2">選手</th>
                        <th scope="col" colspan="3" class="result-tbl-width" nowrap>スコア</th>
                        <th scope="col" colspan="2">選手</th>
                    </tr>
                </thead>
                <tbody>
                    <template v-if="user && user.email">
                        <tr id="match-row" v-for="match in realtimeMatches" :class="getBoundaryStyle(match.start)" data-bs-toggle="modal"  data-bs-target="#inputMatchResultModal" @click="openEditScoreForm(match.event_id, match.match_no)" style="background-color: cornsilk !important;">
                        <td>{{ match.event_id }}<br>{{ match.match_no }}</td>
                        <td>{{ match.start }}<br><span class="court">{{ match.court }}</span></td>
                        <td style="text-align:center; border-right: none;">
                            <TeamLabelComponent :teamId="match.left_team_id_1" :alterText="match.left_entry_id"/>
                            <br>{{match.left_player_name_1 }}
                            <span v-if="match.left_team_id_2 != '' && match.left_team_id_1 != match.left_team_id_2">
                                <br><TeamLabelComponent :teamId="match.left_team_id_2"/>
                            </span>
                            <br>{{ match.left_player_name_2 }}
                        </td>
                        <td style="padding-right:2px; margin:0; width:15px; border-left: none;"><span
                                v-if="match.left_entry_id == match.winner_entry_id"><font-awesome-icon
                                    :icon="['fas', 'circle-check']" style="color: #32cd32" /></span></td>
                        <template v-if="match.left_game1_score && match.right_game1_score">
                            <td class="m-0 p-0 ps-1" style="border-right: none;">{{ match.left_game1_score }}<br>{{ match.left_game2_score }}<br>{{ match.left_game3_score }}</td>
                            <td class="m-0 p-0" style="border-left: none; border-right: none;">-<br>-<br>-</td>
                            <td class="m-0 p-0 pe-1" style="border-left: none;">{{ match.right_game1_score }}<br>{{ match.right_game2_score }}<br>{{ match.right_game3_score }}</td>
                        </template>
                        <template v-if="!match.left_game1_score || !match.right_game1_score">
                            <td class="m-0 p-0 ps-1" style="border-right: none;">{{ match.left_score }}</td>
                            <td class="m-0 p-0" style="border-left: none; border-right: none;">-</td>
                            <td class="m-0 p-0 pe-1" style="border-left: none;">{{ match.right_score }}</td>
                        </template>
                        <td style="padding-left:2px; margin:0; width:15px; border-right: none;"><span
                                v-if="match.right_entry_id == match.winner_entry_id"><font-awesome-icon
                                    :icon="['fas', 'circle-check']" style="color: #32cd32" /></span></td>
                        <td style="text-align:center; border-left: none;">
                            <TeamLabelComponent :teamId="match.right_team_id_1" :alterText="match.right_entry_id"/>
                            <br>{{ match.right_player_name_1 }}
                            <span v-if="match.right_team_id_2 != '' && match.right_team_id_1 != match.right_team_id_2">
                                <br><TeamLabelComponent :teamId="match.right_team_id_2"/>
                            </span>
                            <br>{{ match.right_player_name_2 }}
                        </td>
                        </tr>
                    </template>
                    <!-- ##### -->
                    <template v-if="!user || !user.email" v-for="match in realtimeMatches" >
                        <tr id="match-row" :class="getBoundaryStyle(match.start)" style="background-color: cornsilk !important;">
                        <td>{{ match.event_id }}<br>{{ match.match_no }}</td>
                        <td>{{ match.start }}<br><span class="court">{{ match.court }}</span></td>
                        <td style="text-align:center; border-right: none;">
                            <TeamLabelComponent :teamId="match.left_team_id_1" :alterText="match.left_entry_id"/>
                            <br>{{match.left_player_name_1 }}
                            <span v-if="match.left_team_id_2 != '' && match.left_team_id_1 != match.left_team_id_2">
                                <br><TeamLabelComponent :teamId="match.left_team_id_2"/>
                            </span>
                            <br>{{ match.left_player_name_2 }}
                        </td>
                        <td style="padding-right:2px; margin:0; width:15px; border-left: none;"><span
                                v-if="match.left_entry_id == match.winner_entry_id"><font-awesome-icon
                                    :icon="['fas', 'circle-check']" style="color: #32cd32" /></span></td>
                        <template v-if="match.left_game1_score && match.right_game1_score">
                            <td class="m-0 p-0 ps-1" style="border-right: none;">{{ match.left_game1_score }}<br>{{ match.left_game2_score }}<br>{{ match.left_game3_score }}</td>
                            <td class="m-0 p-0" style="border-left: none; border-right: none;">-<br>-<br>-</td>
                            <td class="m-0 p-0 pe-1" style="border-left: none;">{{ match.right_game1_score }}<br>{{ match.right_game2_score }}<br>{{ match.right_game3_score }}</td>
                        </template>
                        <template v-if="!match.left_game1_score || !match.right_game1_score">
                            <td class="m-0 p-0 ps-1" style="border-right: none;">{{ match.left_score }}</td>
                            <td class="m-0 p-0" style="border-left: none; border-right: none;">-</td>
                            <td class="m-0 p-0 pe-1" style="border-left: none;">{{ match.right_score }}</td>
                        </template>
                        <td style="padding-left:2px; margin:0; width:15px; border-right: none;"><span
                                v-if="match.right_entry_id == match.winner_entry_id"><font-awesome-icon
                                    :icon="['fas', 'circle-check']" style="color: #32cd32" /></span></td>
                        <td style="text-align:center; border-left: none;">
                            <TeamLabelComponent :teamId="match.right_team_id_1" :alterText="match.right_entry_id"/>
                            <br>{{ match.right_player_name_1 }}
                            <span v-if="match.right_team_id_2 != '' && match.right_team_id_1 != match.right_team_id_2">
                                <br><TeamLabelComponent :teamId="match.right_team_id_2"/>
                            </span>
                            <br>{{ match.right_player_name_2 }}
                        </td>
                        </tr>
                    </template>
                </tbody>
            </table>
        </div>
    </div>

    <div class="text-center" v-if="isLoading">
        <div class="spinner-border spinner" role="status">
            <span class="sr-only">Loading...</span>
        </div>
    </div>
    <AffiliateComponent/>

    <SearchFormComponent @doRealtimeSearch="doRealtimeSearch"></SearchFormComponent>
    
    <EditScoreFormComponent :selectedMatchKey="selectedMatchKey" :selectedMatch="selectedMatch" @doReload="doReload"></EditScoreFormComponent>
    <FooterComponent @doFetch="doFetch"></FooterComponent>

</template>

<script setup>
import SearchFormComponent from '@/components/SearchFormComponent.vue'
import EditScoreFormComponent from '@/components/EditScoreFormComponent.vue'
import FooterComponent from '@/components/FooterComponent.vue'
import AffiliateComponent from '@/components/AffiliateComponent.vue'
import TeamLabelComponent from '@/components/TeamLabelComponent.vue'
import { ref, onMounted, computed } from 'vue';
import Firebase from "@/firebase-settings/index.js"
import { ref as fbRef, getDatabase, child, get, onValue, query, orderByChild, startAt, endAt, equalTo, limitToFirst } from "firebase/database"

//
import { getAuth } from "firebase/auth";
import { onBeforeRouteUpdate, useRouter } from 'vue-router'
import { faUserGroup } from '@fortawesome/free-solid-svg-icons';

const router = useRouter()
const auth = getAuth();
const user = auth.currentUser;
// const role = ref();

const db = getDatabase();
const dbRef = fbRef(db);
const isLoading = ref()

const matches = ref([]);
const realtimeMatches = ref([]);
const realtime1 = ref([]);
const realtime2 = ref([]);
const realtime3 = ref([]);
const realtime4 = ref([]);
const unsubscribe1 = ref();
const unsubscribe2 = ref();
const unsubscribe3 = ref();
const unsubscribe4 = ref();
var prevMatchStart = ref("");
const entries = ref([]);
const teams = ref([]);
// const inputMatchResultModal = ref()
const selectedMatchKey = ref()
const selectedMatch = ref([]);

onBeforeRouteUpdate((to, from, next) => {
    next()
});

onMounted(() => {
    // if (user) {
    //     user.getIdTokenResult()
    //     .then((idTokenResult) => {
    //         role.value = idTokenResult.claims.role;
    //     })
    // }
    establishConnection();    
    // doSearch();


});

const establishConnection = () => {
    console.log("establishConnection");
    const matchesRef = fbRef(db, '/2026-summer/matches/');
    unsubscribe1.value = onValue(query(matchesRef, orderByChild('timetable_index'), startAt(900000), endAt(1145999)), (snapshot) => {
        realtime1.value = (snapshot.val());
        doRealtimeSearch();
    });
    onValue(query(matchesRef, orderByChild('timetable_index'), startAt(1146000), endAt(1245999)), (snapshot) => {
        realtime2.value = (snapshot.val());
        doRealtimeSearch();
    });
    onValue(query(matchesRef, orderByChild('timetable_index'), startAt(1246000), endAt(1445999)), (snapshot) => {
        realtime3.value = (snapshot.val());
        doRealtimeSearch();
    });
    onValue(query(matchesRef, orderByChild('timetable_index'), startAt(1446000), endAt(1645999)), (snapshot) => {
        realtime4.value = (snapshot.val());
        doRealtimeSearch();
    });

}


const doRealtimeSearch = () => {
    realtimeMatches.value = { ...realtime1.value, ...realtime2.value, ...realtime3.value, ...realtime4.value }
    localStorage.setItem('matches', JSON.stringify(realtimeMatches.value));
    const eventRegex = new RegExp(createSelectedEventIdRegex(), "i");
    const filterConditionTeam = getFilterConditionTeam();

    if (filterConditionTeam) {
        realtimeMatches.value = Object.fromEntries(
            Object.entries(realtimeMatches.value)
            .filter(([key, value]) =>
                (eventRegex.test(value.event_id.toLowerCase()))
                && ([filterConditionTeam].includes(value.left_team_id_1) || [filterConditionTeam].includes(value.left_team_id_2) || [filterConditionTeam].includes(value.right_team_id_1) || [filterConditionTeam].includes(value.right_team_id_2))
            )
            .sort(function (a, b) {
                if (a[1].timetable_index < b[1].timetable_index) { return -1 }
                if (a[1].timetable_index > b[1].timetable_index) { return 1 }
                // if (parseInt(a[1].start.replace(/:/g, ''), 10) < parseInt(b[1].start.replace(/:/g, ''), 10)) { return -1 }
                // if (parseInt(a[1].start.replace(/:/g, ''), 10) > parseInt(b[1].start.replace(/:/g, ''), 10)) { return 1 }
                // if (a[1].court < b[1].court) { return -1 }
                // if (a[1].court > b[1].court) { return 1 }
                if (a[0] < b[0]) { return -1 }
                if (a[0] > b[0]) { return 1 }
                return 0
            })
        );
    } else {
        realtimeMatches.value = Object.fromEntries(
            Object.entries(realtimeMatches.value)
            .filter(([key, value]) =>
                (eventRegex.test(value.event_id.toLowerCase()))
            )
            .sort(function (a, b) {
                if (parseInt(a[1].start.replace(/:/g, ''), 10) < parseInt(b[1].start.replace(/:/g, ''), 10)) { return -1 }
                if (parseInt(a[1].start.replace(/:/g, ''), 10) > parseInt(b[1].start.replace(/:/g, ''), 10)) { return 1 }
                if (a[1].court < b[1].court) { return -1 }
                if (a[1].court > b[1].court) { return 1 }
                if (a[0] < b[0]) { return -1 }
                if (a[0] > b[0]) { return 1 }
                return 0
            })
        );
    }
}

const doReload = () => {
    // doSearch();
}
 
/**
 * fetch matches from firebase.
 */
const fetchMatches = async () => {
    // const fetchMatches = () => {
    console.log("fetch matches")
    await get(child(dbRef, '/2026-summer/matches')).then((snapshot) => {
        if (snapshot.exists()) {
            // matches.value = JSON.parse(snapshot.val()).sort(function(a,b) {
            //     if (a.start > b.start) {
            //         return 1
            //     }
            //     if (a.start < b.start) {
            //         return -1
            //     }
            //     return 0
            // })
            // const v = JSON.stringify(matches.value)
            // console.log(v)
            // const x = JSON.parse(v)
            // x.sort((a,b) => {
            //     if (a.value.start > b.value.start) {
            //         return -1
            //     }
            //     if (a.value.start < b.value.start) {
            //         return 1
            //     }
            //     return 0
            // })
            localStorage.setItem('matches', JSON.stringify(snapshot.val()));
        } else {
            console.log('No data available')
        }
    }).catch((error) => {
        console.error(error)
    })
};

const fetchEntries = async () => {
    await get(child(dbRef, '/2026-summer/entries')).then((snapshot) => {
        if (snapshot.exists()) {
            entries.value = snapshot.val();
            localStorage.setItem('entries', JSON.stringify(snapshot.val()));
        } else {
            console.log('No data available')
        }
    }).catch((error) => {
        console.error(error)
    })
};

const fetchEvents = () => {
    get(child(dbRef, '/2026-summer/events')).then((snapshot) => {
        if (snapshot.exists()) {
            entries.value = snapshot.val();
            localStorage.setItem('events', JSON.stringify(snapshot.val()));
        } else {
            console.log('No data available')
        }
    }).catch((error) => {
        console.error(error)
    })
};

const fetchTeams = () => {
    get(child(dbRef, '/2026-summer/teams')).then((snapshot) => {
        if (snapshot.exists()) {
            teams.value = snapshot.val();
            localStorage.setItem('teams', JSON.stringify(snapshot.val()));
        } else {
            console.log('No data available')
        }
    }).catch((error) => {
        console.error(error)
    })
};

const openEditScoreForm = (event_id, match_no) => {
    selectedMatchKey.value = event_id + "-" + match_no;
    get(child(dbRef, '/2026-summer/matches/' + event_id + "-" + match_no))
    .then((snapshot) => {
        if (snapshot.exists()) {
            selectedMatch.value = snapshot.val();
        } else {
            console.warn("Not found - match:" + event_id + "-" + match_no)
        }
    });
}

const doFetch = async () => {
    isLoading.value = true;
    // console.log("reloading")
    await fetchEntries()
    // await fetchMatches()
    fetchEvents()
    fetchTeams()
    // setTimeout(() => {
    //     doSearch();
    //     
    // }, 200);
    isLoading.value = false;
}

// const doSearch = () => {
//     doRealtimeSearch();
//     const allMatches = JSON.parse(localStorage.getItem("matches"))

//     const eventRegex = new RegExp(createSelectedEventIdRegex(), "i");

//     console.log(eventRegex)

//     matches.value = allMatches;

//     const filterConditionTeam = getFilterConditionTeam();
//     if (allMatches) {
//         if (filterConditionTeam) {
//             matches.value = Object.fromEntries(
//                 Object.entries(matches.value).filter(([key, value]) =>
//                     // ['*A*'].includes(value.event_id)
//                     // (value.event_id.includes(['T', 'B']) || value.event_id.includes('A')) //&&
//                     (eventRegex.test(value.event_id.toLowerCase())) &&
//                     ([filterConditionTeam].includes(value.left_team_id_1) || [filterConditionTeam].includes(value.left_team_id_2) || [filterConditionTeam].includes(value.right_team_id_1) || [filterConditionTeam].includes(value.right_team_id_2))
//                 ).sort(function (a, b) {
//                     if (parseInt(a[1].start.replace(/:/g, ''), 10) < parseInt(b[1].start.replace(/:/g, ''), 10)) { return -1 }
//                     if (parseInt(a[1].start.replace(/:/g, ''), 10) > parseInt(b[1].start.replace(/:/g, ''), 10)) { return 1 }
//                     if (a[1].court < b[1].court) { return -1 }
//                     if (a[1].court > b[1].court) { return 1 }
//                     if (a[0] < b[0]) { return -1 }
//                     if (a[0] > b[0]) { return 1 }
//                     return 0
//                 })
//             );
//             // matches.value = Object.fromEntries(Object.entries(matches.value).sort(function(a,b) {
//             //     if (a[1].start < b[1].start) { return -1 }
//             //     if (a[1].start > b[1].start) { return 1 }
//             //     return 0
//             // }))

//         } else {
//             matches.value = Object.fromEntries(
//                 Object.entries(matches.value).filter(([key, value]) =>
//                     (eventRegex.test(value.event_id.toLowerCase())))
//                     .sort(function (a, b) {
//                         if (parseInt(a[1].start.replace(/:/g, ''), 10) < parseInt(b[1].start.replace(/:/g, ''), 10)) { return -1 }
//                         if (parseInt(a[1].start.replace(/:/g, ''), 10) > parseInt(b[1].start.replace(/:/g, ''), 10)) { return 1 }
//                         // if (Number(a[1].start) < Number(b[1].start)) { return -1 }
//                         // if (Number(a[1].start) > Number(b[1].start)) { return 1 }
//                         if (a[1].court < b[1].court) { return -1 }
//                         if (a[1].court > b[1].court) { return 1 }
//                         if (a[0] < b[0]) { return -1 }
//                         if (a[0] > b[0]) { return 1 }
//                         return 0
//                     })
//             );
//             // ['6A'].includes(value.event_id)))
//         }
//     }

// };

const createSelectedEventIdRegex = () => {

    const allCombinations = [];

    var jsonData = localStorage.getItem("filterConditionGrade");
    var grade = "";
    var gender = ""
    var group = "";
    if (jsonData) {
        grade = JSON.parse(jsonData);
    }
    jsonData = localStorage.getItem("filterConditionGender");
    if (jsonData) {
        gender = JSON.parse(jsonData);
    }
    jsonData = localStorage.getItem("filterConditionGroup");
    if (jsonData) {
        group = JSON.parse(jsonData);
    }

    if (grade.length === 0 && gender.length === 0 && group.length === 0) {
        allCombinations.push('');
    } else {
        for (const g of grade.length === 0 ? [''] : grade) {
            for (const gen of gender.length === 0 ? [''] : gender) {
                for (const grp of group.length === 0 ? [''] : group) {
                    // if (grade) {
                    //     console.log(grade)
                    // }
                    const combination = `${g}${gen}${grp}`;
                    allCombinations.push(combination.toUpperCase());
                }
            }
        }
    }
    if (allCombinations) {
        return allCombinations.join("|")
    } else {
        return '*'
    }

}

const getFilterConditionTeam = () => {
    const jsonData = localStorage.getItem("filterConditionTeam");
    if (jsonData) {
        return JSON.parse(jsonData);
    } else {
        return ""
    }
}

const getBoundaryStyle = (matchStart) => {

    if (prevMatchStart == matchStart) {
        return "";
    } else {
        prevMatchStart = matchStart
        return "boundary";
    }
}

</script>

<style scoped>

#result-tbl {
    border-color: #dee2e6;
}
.result-tbl-width {
    width: 80px;
}

tr.boundary {
    border-top: 2px solid #198754;
}

.court {
    display: inline-block;
    font-size: 0.85em;
    padding: 0.0em;
    text-decoration: none;
    background: #d1e7dd;
    /* background: #ff0000; */
    color: black;
    width: 35px;
    margin: 1px;
    text-align: center;
    white-space: nowrap;
    vertical-align: bottom;
}

.spinner {
  position: fixed;
  left: 50%;
  top: 20%;
  margin: 0px auto;
  z-index: 999;
}

@media screen and (max-width: 768px) {
    .result-tbl-width {
        width: 45px;
    }
}

</style>